module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pageChanged(1)
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _vm._l((_vm.paginationRange), function(n) {
    return _c('li', {
      key: n,
      class: _vm.activePage(n),
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.pageChanged(n)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(n))])])
  }), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pageChanged(_vm.lastPage)
      }
    }
  }, [_vm._m(1)])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#",
      "aria-label": "Previous"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("«")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#",
      "aria-label": "Next"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("»")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d10b4f8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pagination/Pagination.vue
// module id = 868
// module chunks = 1